import axios, { AxiosInstance } from 'axios'

import { envConfigs } from '@/constants/config'

const REQUEST_TIMEOUT_MS = 5000

let cachedInstance: AxiosInstance | null = null

// LINE 購物導購事件回拋用的獨立 axios instance：
// - 不帶 access token
// - 不走 service.js 的 toast / sentry / snake_case 轉換
// - 短 timeout，避免拖累呼叫端
export const getLineShopTrackingClient = (): AxiosInstance => {
  if (cachedInstance) return cachedInstance

  cachedInstance = axios.create({
    baseURL: envConfigs.apiUrl,
    timeout: REQUEST_TIMEOUT_MS,
    headers: {
      'Content-Type': 'application/json',
    },
  })

  return cachedInstance
}
